var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSourceSheetSymbolBold(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 137,
    height: 92,
    viewBox: "0 0 137 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.b{clip-path:url(#a);}.c{stroke:#001f4c;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 137,
    height: 92,
    rx: 4,
    transform: "translate(784.916 19)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(-784.916 -19)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, -774.602, -241.383)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1525.674,703.283V748.5l-18.087-13.565L1489.5,748.5V703.283a6.773,6.773,0,0,1,6.782-6.783h36.174",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1512.282,696.5h0a6.782,6.782,0,0,1,6.783,6.783v13.565H1505.5V703.283A6.782,6.782,0,0,1,1512.282,696.5Z",
    transform: "translate(20.174 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSourceSheetSymbolBold);
export default __webpack_public_path__ + "static/media/source-sheet-symbol-bold.dba11689bdd60f7db9cf1f07b7deb749.svg";
export { ForwardRef as ReactComponent };